import { ReactElement, CSSProperties, JSX } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
import { Lang } from "../../sharedTypes";

interface SXModalBaseProps {
  header: string | JSX.Element;

  show?: boolean;
  size?: "sm" | "lg" | "xl";

  close?: () => void;
  style?: CSSProperties;

  body: ReactElement | null;
  bodyStyle?: CSSProperties;

  footer: ReactElement | null;
  className?: string;
}
export const SXModalBase = (props: SXModalBaseProps) => {
  return (
    <>
      <Modal
        className={`sxmodal ${props.className ?? ""}`}
        size={props.size}
        show={props.show}
        onHide={props.close}
        style={props.style}
      >
        <Container id="sx-modal-container">
          <Row className="sx-modal-header align-items-center">
            <Col className="text-center sx-modal-header-bg">
              <Modal.Header closeButton={!!props.close}>
                <Modal.Title className="headerModal">{props.header}</Modal.Title>
              </Modal.Header>
            </Col>
          </Row>
        </Container>

        <Modal.Body style={props.bodyStyle}>{props.body}</Modal.Body>

        <Modal.Footer className="sx-modal-footer">{props.footer}</Modal.Footer>
      </Modal>
    </>
  );
};

/* props.close (not .onClose) */
export const SXModalButtonCancel = (props: { lang: Lang; close: (reason: number) => void }) => {
  let userLang: Lang = "en";
  userLang = props.lang;

  return (
    <Button
      id="modal_button_cancel"
      data-testid="modal_footer_button_cancel"
      // style={{ zIndex: 9999999 }}
      className="sx-modal-btn"
      onClick={(e) => {
        props.close(-1);
      }}
    >
      cancel_
    </Button>
  );
};
